export default __webpack_public_path__ + "images/logoCnet.97c304594e1319e22e0488b0cabbf8d6.svg"